var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 170,
    viewBox: "0 0 227 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214 44C225.046 44 234 35.0457 234 24C234 12.9543 225.046 4 214 4C202.954 4 194 12.9543 194 24C194 35.0457 202.954 44 214 44Z",
    fill: "#E0F3E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224 26H204C202.896 26 202 25.104 202 24C202 22.896 202.896 22 204 22H224C225.104 22 226 22.896 226 24C226 25.104 225.104 26 224 26Z",
    fill: "#229B61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212 34V14C212 12.896 212.896 12 214 12C215.104 12 216 12.896 216 14V34C216 35.104 215.104 36 214 36C212.896 36 212 35.104 212 34Z",
    fill: "#229B61"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_6553_29208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 193.5C74.4721 193.5 93.5 174.472 93.5 151C93.5 127.528 74.4721 108.5 51 108.5C27.5279 108.5 8.5 127.528 8.5 151C8.5 174.472 27.5279 193.5 51 193.5Z",
    fill: "#E0F3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.25 155.25H29.75C27.404 155.25 25.5 153.346 25.5 151C25.5 148.654 27.404 146.75 29.75 146.75H72.25C74.596 146.75 76.5 148.654 76.5 151C76.5 153.346 74.596 155.25 72.25 155.25Z",
    fill: "#229B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.75 172.25V129.75C46.75 127.404 48.654 125.5 51 125.5C53.346 125.5 55.25 127.404 55.25 129.75V172.25C55.25 174.596 53.346 176.5 51 176.5C48.654 176.5 46.75 174.596 46.75 172.25Z",
    fill: "#229B61"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175 142.042C193.64 142.042 208.75 127.025 208.75 108.5C208.75 89.9754 193.64 74.9583 175 74.9583C156.36 74.9583 141.25 89.9754 141.25 108.5C141.25 127.025 156.36 142.042 175 142.042Z",
    fill: "#E7EBFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175 61.5417C182.456 61.5417 188.5 55.5348 188.5 48.125C188.5 40.7152 182.456 34.7083 175 34.7083C167.544 34.7083 161.5 40.7152 161.5 48.125C161.5 55.5348 167.544 61.5417 175 61.5417Z",
    fill: "#E7EBFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175 182.292C182.456 182.292 188.5 176.285 188.5 168.875C188.5 161.465 182.456 155.458 175 155.458C167.544 155.458 161.5 161.465 161.5 168.875C161.5 176.285 167.544 182.292 175 182.292Z",
    fill: "#E7EBFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.39 152.104C129.846 152.104 135.89 146.097 135.89 138.688C135.89 131.278 129.846 125.271 122.39 125.271C114.935 125.271 108.89 131.278 108.89 138.688C108.89 146.097 114.935 152.104 122.39 152.104Z",
    fill: "#E7EBFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.61 91.7292C235.065 91.7292 241.11 85.7223 241.11 78.3125C241.11 70.9027 235.065 64.8958 227.61 64.8958C220.154 64.8958 214.11 70.9027 214.11 78.3125C214.11 85.7223 220.154 91.7292 227.61 91.7292Z",
    fill: "#E7EBFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.61 152.104C235.065 152.104 241.11 146.097 241.11 138.688C241.11 131.278 235.065 125.271 227.61 125.271C220.154 125.271 214.11 131.278 214.11 138.688C214.11 146.097 220.154 152.104 227.61 152.104Z",
    fill: "#F5F5FC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M122.39 91.7292C129.846 91.7292 135.89 85.7223 135.89 78.3125C135.89 70.9027 129.846 64.8958 122.39 64.8958C114.935 64.8958 108.89 70.9027 108.89 78.3125C108.89 85.7223 114.935 91.7292 122.39 91.7292Z",
    fill: "#E7EBFC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M175 108.5C180.592 108.5 185.125 103.995 185.125 98.4375C185.125 92.8801 180.592 88.375 175 88.375C169.408 88.375 164.875 92.8801 164.875 98.4375C164.875 103.995 169.408 108.5 175 108.5Z",
    fill: "url(#paint0_linear_6553_29208)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.813 115.208H163.188C160.791 115.208 158.712 116.282 157.187 117.885C160.589 124.244 167.244 128.625 175 128.625C182.756 128.625 189.411 124.244 192.813 117.885C191.288 116.282 189.209 115.208 186.813 115.208Z",
    fill: "url(#paint1_linear_6553_29208)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.856 86.3223L135.836 78.279C135.843 80.5732 135.317 82.8943 134.081 85.0208C132.846 87.1474 131.084 88.7641 129.086 89.8978L143.12 97.9478C144.578 93.6075 146.859 89.6764 149.856 86.3223Z",
    fill: "url(#paint2_linear_6553_29208)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175 74.9583C177.315 74.9583 179.57 75.1931 181.75 75.6359V59.6835C179.759 60.8306 177.47 61.5417 175 61.5417C172.53 61.5417 170.241 60.8306 168.25 59.6835V75.6359C170.43 75.1931 172.685 74.9583 175 74.9583Z",
    fill: "url(#paint3_linear_6553_29208)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206.88 97.9545L220.914 89.9045C218.916 88.7641 217.154 87.1541 215.919 85.0276C214.683 82.901 214.157 80.5799 214.164 78.2857L200.144 86.329C203.141 89.6764 205.422 93.6075 206.88 97.9545Z",
    fill: "url(#paint4_linear_6553_29208)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.12 119.045L129.086 127.095C131.084 128.236 132.846 129.846 134.081 131.972C135.317 134.099 135.843 136.42 135.836 138.714L149.856 130.671C146.859 127.324 144.578 123.392 143.12 119.045Z",
    fill: "url(#paint5_linear_6553_29208)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175 142.042C172.685 142.042 170.43 141.807 168.25 141.364V157.317C170.241 156.169 172.53 155.458 175 155.458C177.47 155.458 179.759 156.169 181.75 157.317V141.364C179.57 141.807 177.315 142.042 175 142.042Z",
    fill: "url(#paint6_linear_6553_29208)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.144 130.671L214.164 138.714C214.157 136.427 214.683 134.099 215.919 131.972C217.154 129.846 218.916 128.229 220.914 127.095L206.88 119.045C205.422 123.392 203.141 127.324 200.144 130.671Z",
    fill: "url(#paint7_linear_6553_29208)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6553_29208",
    x: -4,
    y: 96,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_6553_29208"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6553_29208",
    x1: 175,
    y1: 88.375,
    x2: 175,
    y2: 108.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A81F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6553_29208",
    x1: 175,
    y1: 115.208,
    x2: 175,
    y2: 128.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A81F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6553_29208",
    x1: 139.471,
    y1: 78.279,
    x2: 139.471,
    y2: 97.9478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A81F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6553_29208",
    x1: 175,
    y1: 59.6835,
    x2: 175,
    y2: 75.6359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A81F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6553_29208",
    x1: 210.529,
    y1: 78.2857,
    x2: 210.529,
    y2: 97.9545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A81F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6553_29208",
    x1: 139.471,
    y1: 119.045,
    x2: 139.471,
    y2: 138.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A81F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6553_29208",
    x1: 175,
    y1: 141.364,
    x2: 175,
    y2: 157.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A81F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6553_29208",
    x1: 210.529,
    y1: 119.045,
    x2: 210.529,
    y2: 138.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A81F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDefault);
export default __webpack_public_path__ + "static/media/illustration-default.fd8d2d7c747b59721eaaf9e8718f26ef.svg";
export { ForwardRef as ReactComponent };